if (!customElements.get('queen-home-rail')) {
  customElements.define('queen-home-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('.qn-home-rail__track');
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => {
          const direction = Number(button.dataset.direction);
          const max = track.scrollWidth - track.clientWidth;
          let left = track.scrollLeft + direction * track.clientWidth;
          if (direction > 0 && track.scrollLeft >= max - 2) left = 0;
          if (direction < 0 && track.scrollLeft <= 2) left = max;
          track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        });
      });
    }
  });
}
